import React from 'react';
import Transactions from '.';

const CollectionTransactions = () => (
  <>
    <Transactions
      title="Collection Transactions"
      transactionType="COLLECTION"
    />
  </>
);

export default CollectionTransactions;
